import { useState, useEffect } from "react";
import Header from "./Header";
import AddTodo from "./AddTodo";
import List from "./common/List";
import Footer from "./Footer";
import { listTasks } from "../api/todo";

const Todo = () => {
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    listTasks((data) => {
      setTasks(data);
    });
  }, []);

  return (
    <div className="todo">
      <Header />
      <div className="container">
        <AddTodo setTasks={setTasks} />
        <hr />
        <List tasks={tasks} setTasks={setTasks} />
      </div>
      <Footer />
    </div>
  );
};

export default Todo;
